import * as React from "react"

const ContentPara = ({ blok, len }) => (
  <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900 p-2">
    {blok.Paragraph}
  </p>
)

export default ContentPara
